import Button from '@hig/button';
import '@hig/button/build/index.css';
import { t, Trans } from '@lingui/macro';
import { I18n } from '@lingui/react';
import log from 'loglevel';
import PropTypes from 'prop-types';
import React from 'react';
import * as api from '../../apis/api';
import { totalMinutes, waitTimeTimeout } from '../../app.config';
import { getEstimatedWaitTime } from '../../utils/waitTimeHelpers';
import ErrorBoundary from '../ErrorBoundary';
import '../UserInfoForm/UserInfoForm.styles';
import * as Styles from '../UserInfoForm/UserInfoForm.styles.js';

class CallbackValidate extends React.PureComponent {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      ...props.variables,
      returnBack: this.props.returnBack,
      closeModal: this.props.closeModal,
      setValidated: this.props.setValidated,
      waitTime: -1,
      waitTimeNotes: '',
      buttonDisabled: false,
      showUnavailable: false,
      showNoAgent: false,
      inactivePage: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const data = {
      contactId: this.props.variables.contactId,
      skillId: this.props.variables.skillId,
      requestId: this.props.variables.requestId,
    };
    getEstimatedWaitTime(data, this, true);
    this.interval = setInterval(() => getEstimatedWaitTime(data, this, true), waitTimeTimeout);
    setTimeout(() => { clearInterval(this.interval); }, totalMinutes);
  }

  componentWillUnmount() {
    this._isMounted = false;
    log.debug('Interval', this.interval);
    if (typeof this.interval !== 'undefined') {
      clearInterval(this.interval);
    }
  }

  onSubmit = () => {
    document.querySelector('.button-spinner').style.display = '';

    this.setState({
      buttonDisabled: true,
    },
    () => document.querySelector('.hig__button-v1.hig__button-v1--disabled').style.opacity = '0.5');

    const data = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      fullName: this.state.fullName,
      email: this.state.email,
      phone: this.state.phone,
      issue: this.state.issue,
      buttonDisabled: this.state.buttonDisabled,
      skillId: this.state.skillId,
      requestId: this.state.requestId,
      userSessionId: this.state.userSessionId,
    };

    const personalConnData = {
      email: this.state.email,
      phoneNumber: this.state.phone,
      fullName: this.state.fullName,
      supportQuestion: this.state.issue,
      skillId: this.state.skillId,
      requestId: this.state.requestId,
    }

    api.getPersonalConnection(personalConnData)
      .then((result) => {
        log.debug('api.getPersonalConnection', result);
        if (Object.keys(result.data).length) {
          const updatedData = {
            ...data,
            contactId: result.data.InContactId,
          }

          this.setState({
            variables: updatedData,
          },
          () => { this.props.setValidated(updatedData) }
          );
        } else {
          log.error('api.getPersonalConnection result.data is empty');
          this.setState({
            inactivePage: true,
            showUnavailable: true,
          });
          document.querySelector('.button-spinner').style.display = 'none';
        }
      })
      .catch((error) => {
        log.error('api.getPersonalConnection', error);
        this.setState({
          inactivePage: true,
          showUnavailable: true,
        });
        document.querySelector('.button-spinner').style.display = 'none';
      });
  }

  render() {
    return (
      <ErrorBoundary>
        <Styles.StyledWrapper>
          <Styles.StyledForm>
            <Styles.StyledH1>
              <Trans>Verify your details</Trans>
            </Styles.StyledH1>
            <Styles.StyledErrorNotice>
              <div id='unavailable' style={{ display: this.state.showUnavailable ? 'block' : 'none' }}>
                <I18n>
                  {({ i18n }) => (
                    i18n._(t`Service is unavailable at the moment. Please try again later.`)
                  )}
                </I18n>
              </div>
              <div id='no-agent' style={{ display: this.state.showNoAgent ? 'block' : 'none' }}>
                <I18n>
                  {({ i18n }) => (
                    i18n._(t`No agents are available at the moment. Please try again later.`)
                  )}
                </I18n>
              </div>
            </Styles.StyledErrorNotice>
            <Styles.StyledFlexRow>
              <Styles.StyledFlexColumn>
                <Styles.StyledStandardText
                  className={this.state.inactivePage ? 'inactive-page' : ''}
                  style={{ display: this.state.inactivePage ? 'none' : 'block' }}
                >
                  <div className='text-spinner' style={{ display: this.state.waitTime === -1 ? 'block' : 'none' }}></div>
                  <div style={{ display: this.state.waitTime === -1 ? 'none' : 'block' }}>
                    <Trans>
                      Estimated wait time: about {this.state.waitTime} minutes
                    </Trans>
                  </div>
                </Styles.StyledStandardText>
                <Styles.StyledLargeText className={this.state.inactivePage ? 'inactive-page' : ''}>
                  <Trans>Hello, {this.state.fullName}.</Trans>
                  <br />
                  <Trans>We will call you at <Styles.StyledBoldText>{this.props.variables.phone}</Styles.StyledBoldText>. To change your number, click <Styles.StyledBoldText>Back</Styles.StyledBoldText>.</Trans>
                  <br />
                  <Trans>To initiate a call, click <Styles.StyledBoldText>Request a call</Styles.StyledBoldText>.</Trans>
                </Styles.StyledLargeText>
              </Styles.StyledFlexColumn>
            </Styles.StyledFlexRow>
          </Styles.StyledForm>
          <Styles.StyledLine color="#cccccc"></Styles.StyledLine>
          <Styles.StyledFormSubmission>
            <Styles.StyledFlexRow>
              <Styles.StyledFlexColumn>
                <Styles.StyledPrimaryCtaButton>
                  <div className='button-spinner' style={{ display: 'none' }}></div>
                  <I18n>
                    {({ i18n }) => (
                      <Button
                        size="large"
                        title={i18n._(t`REQUEST CALL`)}
                        onClick={() => this.onSubmit()}
                        data-wat-val="request a call after verify"
                        disabled={this.state.inactivePage ? true : this.state.buttonDisabled}
                      />
                    )}
                  </I18n>
                </Styles.StyledPrimaryCtaButton>
              </Styles.StyledFlexColumn>
              <Styles.StyledFlexColumn>
                <Styles.StyledSecondaryCtaButton>
                  <I18n>
                    {({ i18n }) => (
                      <Button
                        size="large"
                        title={i18n._(t`CANCEL`)}
                        data-wat-val="cancel call after verify"
                        onClick={() => this.state.closeModal()}
                        type="secondary"
                      />
                    )}
                  </I18n>
                </Styles.StyledSecondaryCtaButton>
              </Styles.StyledFlexColumn>
              <Styles.StyledFlexColumn>
                <Styles.StyledSecondaryCtaButton>
                  <I18n>
                    {({ i18n }) => (
                      <Button
                        size="large"
                        title={i18n._(t`BACK`)}
                        data-wat-val="go back after verify"
                        onClick={() => { this.state.returnBack(this.props.variables) }}
                        type="secondary"
                      />
                    )}
                  </I18n>
                </Styles.StyledSecondaryCtaButton>
              </Styles.StyledFlexColumn>
            </Styles.StyledFlexRow>
          </Styles.StyledFormSubmission>
        </Styles.StyledWrapper>
      </ErrorBoundary>
    );
  }
}

CallbackValidate.propTypes = {
  variables: PropTypes.object,
  returnBack: PropTypes.func,
  closeModal: PropTypes.func,
  setValidated: PropTypes.func,
};

export default CallbackValidate;
